import { NavigationProps } from './Props';
import { NavigationBar } from './NavigationBar';
import { useCurrentUser } from '../../Lib/Contexts/CurrentUserContext';
import Roles from '../../Lib/Constants/roles';
// TODO: [HALO-MIGRATION] Remove HaloMigrationBanner import after migration is complete
import HaloMigrationBanner from '../HaloMigrationBanner/HaloMigrationBanner';
// TODO: [HALO-MIGRATION] Remove HaloMigrationModal import after migration is complete
import HaloMigrationModal from '../HaloMigrationBanner/HaloMigrationModal';

export function NavigationFullPage(props: NavigationProps) {
  const { children, ...otherProps } = props;
  const { currentUser } = useCurrentUser();

  // TODO: [HALO-MIGRATION] Remove migration logic after migration is complete
  const migrationType = currentUser?.migrated_to_halo;
  const isMigrated =
    currentUser?.role === Roles.INFLUENCER &&
    (migrationType === 'influencer' || migrationType === 'agency');

  return (
    <div className="flex flex-col h-full overflow-hidden">
      {/* TODO: [HALO-MIGRATION] Remove HaloMigrationModal after migration is complete */}
      {isMigrated && migrationType && (
        <HaloMigrationModal migrationType={migrationType} />
      )}
      {/* TODO: [HALO-MIGRATION] Remove HaloMigrationBanner after migration is complete */}
      {migrationType && isMigrated && <HaloMigrationBanner />}
      <div className="flex flex-row flex-1 overflow-hidden">
        <NavigationBar {...otherProps} />
        <div className="overflow-auto w-full">{children}</div>
      </div>
    </div>
  );
}
